import React, { useMemo } from 'react'
import { ReactComponent as AlertIcon } from '@assets/images/Icons/Alert.svg'
import { ReactComponent as AttentionIcon } from '@assets/images/Icons/Attention.svg'
import { ReactComponent as Checkmark2Icon } from '@assets/images/Icons/Checkmark2.svg'
import { ReactComponent as InfoIcon } from '@assets/images/Icons/Info.svg'
import type { ToastProps, ToastVariant } from './Toast.types'
import { TOAST_DEFAULT_MESSAGE } from './Toast.types'
import './Toast.css'

const variantIconMap: Record<ToastVariant, React.ReactNode> = {
  info: <InfoIcon className="ds-toast__icon-graphic" aria-hidden="true" />,
  success: (
    <Checkmark2Icon className="ds-toast__icon-graphic" aria-hidden="true" />
  ),
  warning: (
    <AttentionIcon className="ds-toast__icon-graphic" aria-hidden="true" />
  ),
  danger: <AlertIcon className="ds-toast__icon-graphic" aria-hidden="true" />,
}

const Toast: React.FC<ToastProps> = ({
  variant = 'info',
  message = TOAST_DEFAULT_MESSAGE,
  children,
  className = '',
  style,
  darkMode = false,
  previewVariant,
  role,
}) => {
  const resolvedVariant = previewVariant ?? variant
  const content = children ?? message
  const resolvedRole =
    role ?? (resolvedVariant === 'danger' ? 'alert' : 'status')

  const classNames = useMemo(
    () =>
      [
        'ds-toast',
        `ds-toast--${resolvedVariant}`,
        darkMode ? 'ds-toast--dark' : '',
        previewVariant ? 'ds-toast--preview' : '',
        className,
      ]
        .filter(Boolean)
        .join(' '),
    [className, darkMode, previewVariant, resolvedVariant],
  )

  return (
    <div className={classNames} style={style} role={resolvedRole}>
      <span className="ds-toast__icon">{variantIconMap[resolvedVariant]}</span>
      <p className="ds-toast__message">{content}</p>
    </div>
  )
}

export default Toast
